import React from "react";
import { useAufgabenFilters } from "../../../../features/aufgaben";
import { getErrorMessage } from "../../../../shared/lib/errors/getErrorMessage";
import { AufgabenListView } from "./AufgabenListView";

export const AufgabenList: React.FC = () => {
  const { data, error, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useAufgabenFilters();

  const items = data?.items ?? [];

  const handleLoadMore = () => {
    if (!hasNextPage || isFetchingNextPage) {
      return;
    }
    void fetchNextPage();
  };

  if (error)
    return (
      <div className="my-2 w-full rounded-md border border-[#E63312] bg-[#FFF3F0] p-3">
        <p className="font-['PT_Sans'] text-[16px] font-bold text-[#E63312]">
          {getErrorMessage(error)}
        </p>
      </div>
    );

  return (
    <AufgabenListView
      items={items}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasMore={Boolean(hasNextPage)}
      onLoadMore={handleLoadMore}
    />
  );
};
